/**
 * Luma Group
 *
 * @author Robuust
 */

import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';

/**
 * Controller for animated statistics.
 */
export default class extends Controller {
  static targets = ['value'];

  timeline;

  /**
   * Animate statistics when they enter the viewport.
   */
  connect() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: 'top 75%',
        once: true,
      },
    });

    this.valueTargets.forEach((element) => {
      const value = Number(element.dataset.statisticsValue);

      if (!Number.isFinite(value)) {
        return;
      }

      element.replaceChildren('0');

      this.timeline.to(
        element,
        {
          textContent: value,
          duration: 3,
          ease: 'power2.out',
          snap: {
            textContent: 1,
          },
        },
        0,
      );
    });
  }

  /**
   * Clean up the statistics animation.
   */
  disconnect() {
    this.timeline?.scrollTrigger?.kill();
    this.timeline?.kill();
  }
}
